var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"waypoint",rawName:"v-waypoint",value:({ active: true, callback: _vm.onWaypoint, options: _vm.intersectionOptions }),expression:"{ active: true, callback: onWaypoint, options: intersectionOptions }"}],staticClass:"waypoint"},_vm._l((_vm.compList),function(item){return _c(item,{key:item,tag:"component"})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }